<template>
  <pre v-html="article"></pre>
</template>
<script>
export default {
  inject: ["reload"],
  watch: {
    $route(to, from) {
      this.reload();
    },
  },
  data() {
    return {
      article: "", //文章内容
    };
  },
  activated: {},
  created() {
    let data = localStorage.getItem("content");
    this.article = data;
  },
};
</script>

